import { RejectedFile, FileRejectionReason } from '@co-3/ctrl-ui/forms';

export const createMessageFromRejectedFiles = (rejectedFiles: RejectedFile[]): string => {
    let message = 'nicht ausgewählt werden.\n\n\n';
    if (rejectedFiles.length > 1) {
        message = 'Einige Dateien konnten ' + message;
    } else {
        message = 'Eine Datei konnte ' + message;
    }
    const tooBigFiles = rejectedFiles.filter((file) => file.reason === FileRejectionReason.FILE_TOO_BIG);

    if (tooBigFiles.length > 0) {
        if (tooBigFiles.length > 1) {
            message += 'Die folgenden Dateien sind zu groß:\n\n';
        } else {
            message += 'Die folgende Datei ist zu groß:\n\n';
        }

        tooBigFiles.forEach((file) => {
            const fileName = file.file.name.length > 45 ? file.file.name.substring(0, 45) + '...' : file.file.name;
            message += '- ' + fileName + '\n';
        });
        message += '\nDie maximal erlaubte Dateigröße ist 10mb\n\n\n';
    }

    const fileTypeFiles = rejectedFiles.filter((file) => file.reason === FileRejectionReason.FILE_TYPE_NOT_ALLOWED);
    if (fileTypeFiles.length > 0) {
        if (fileTypeFiles.length > 1) {
            message += 'Die folgenden Dateien haben ';
        } else {
            message += 'Die folgende Datei hat ';
        }
        message += 'einen Dateityp, der nicht akzeptiert wird:\n\n';
        fileTypeFiles.forEach((file) => {
            const fileName = file.file.name.length > 45 ? file.file.name.substring(0, 45) + '...' : file.file.name;
            message += '- ' + fileName + '\n';
        });
        message += '\nErlaubt sind Bilddateien und PDF-Dokumente';
    }
    return message;
};
